export default __webpack_public_path__ + "maps-examples-data-driven-symbols-thumbnail-960-219931ad8010845d5a22821466b04d0d.webp";